import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#3f3f3f',
    secondary: '#6e6e6e',
    accent: '#4476bb',
    error: '#b71c1c'
  }
})
